<template>
  <section class="anchor security-profile" :id="$t('header.nav[4].link')">
    <div class="container">
      <div class="row">
        <div class="col-x-lg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="security-profile__image">
            <img src="~@/assets/img/home/security-profile/product.png" alt="" />
          </div>
        </div>
        <div class="col-x-lg-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
          <div class="security-profile__description">
            <h2
              class="security-profile__description-title"
              v-html="$t('home.securityProfile.title')"
            ></h2>
            <h5
              class="security-profile__description-subtitle"
              v-html="$t('home.securityProfile.subtitle')"
            ></h5>
            <div
              class="security-profile__description-text"
              v-html="$t('home.securityProfile.text')"
            ></div>
            <div
              class="security-profile__description-info"
              v-html="$t('home.securityProfile.info')"
            ></div>
            <router-link
              @click.native="mainMaSafe()"
              :to="$t('home.securityProfile.button.link')"
              class="security-profile__description-btn"
            >
              {{ $t("home.securityProfile.button.title") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SecurityProfile",
  methods: {
    mainMaSafe() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_ma_safe" });
    }
  }
};
</script>
